import type { ClientAddress } from '@DigitaleDoerfer/digitale-doerfer-api';

import type { OsmPlace } from '@/features/geo-coding/types/place';

export const getAddressFromResult = (result: OsmPlace | undefined) => {
  const id = result?.osm_id ?? result?.place_id ?? 'lookup';
  const street = [result?.address?.road, result?.address?.house_number]
    .filter(Boolean)
    .join(' ');
  const city =
    result?.address?.city ??
    result?.address?.village ??
    result?.address?.municipality;
  return {
    id: id,
    name: [street, [result?.address?.postcode, city].filter(Boolean).join(' ')]
      .filter(Boolean)
      .join(', '),
    city,
    street,
    zip: result?.address?.postcode,
    gpsLocation:
      result?.lat != undefined && result?.lon != undefined
        ? {
            latitude: result?.lat,
            longitude: result?.lon
          }
        : undefined
  } as ClientAddress;
};

export const getLocationString = (place: OsmPlace) => {
  const street = [place?.address?.road, place?.address?.house_number]
    .filter(Boolean)
    .join(' ');
  const city =
    place?.address?.city ??
    place?.address?.village ??
    place?.address?.municipality;
  return [street, [place?.address?.postcode, city].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
};

export const getAdressString = (place?: ClientAddress) => {
  if (!place) return;
  return [place?.street, [place?.zip, place?.city].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
};
